// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"673":"df849582","748":"33a4cfb5","767":"78c2d6f4"}[chunkId] + ".chunk.js";
};